import React, { useCallback } from 'react';
import { useLocation, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import ProcesosWorkflowPeriodosModal from './ProcesosWorkflowPeriodosModal';
import type { ProcesosOutletContext } from './procesos-periodo-page';
import {
  parseProcesosEmpresaId,
  parseProcesosEmpresaWorkflowId,
  procesosEmpresaWorkflowsPath,
  type ProcesosEmpresaLocationState,
} from './procesos-empresa-routes';
import { readProcesosReturnSearch } from './procesos-workflow-routes';
import { parsePeriodoIdParam } from './procesos-no-creados';

export default function ProcesosEmpresaWorkflowPeriodosModalRoute() {
  const navigate = useNavigate();
  const location = useLocation();
  const { empresaId: empresaIdParam, workflowId: workflowIdParam } = useParams();
  const { refreshAfterPeriodoChange } = useOutletContext<ProcesosOutletContext>();
  const state = location.state as ProcesosEmpresaLocationState | null;
  const procesosReturnSearch = readProcesosReturnSearch(state);
  const returnPath = state?.returnPath || '/procesos';
  const empresaId = parseProcesosEmpresaId(location.pathname)
    ?? (Number(empresaIdParam) > 0 ? Number(empresaIdParam) : null);
  const workflowId = parseProcesosEmpresaWorkflowId(location.pathname)
    ?? (Number(workflowIdParam) > 0 ? Number(workflowIdParam) : null);
  const periodoId = parsePeriodoIdParam(location.search);

  const handleClose = useCallback(() => {
    navigate(`${returnPath}${procesosReturnSearch}`);
  }, [navigate, procesosReturnSearch, returnPath]);

  const handleBack = useCallback(() => {
    if (empresaId == null) return;
    navigate(procesosEmpresaWorkflowsPath(empresaId, procesosReturnSearch), {
      state: {
        procesosSearch: procesosReturnSearch,
        returnPath,
        empresaLabel: state?.empresaLabel,
      },
    });
  }, [empresaId, navigate, procesosReturnSearch, returnPath, state?.empresaLabel]);

  if (empresaId == null || workflowId == null) return null;

  return (
    <ProcesosWorkflowPeriodosModal
      open
      workflowId={workflowId}
      empresaId={empresaId}
      empresaLabel={state?.empresaLabel}
      periodoId={periodoId}
      backLabel="Workflows"
      onClose={handleClose}
      onBack={handleBack}
      onProcesosCreated={refreshAfterPeriodoChange}
    />
  );
}
